import React from "react";

import { inputLayerGroups } from "fond/layers";
import { useAppDispatch, useAppSelector } from "fond/utils/hooks";
import { useStackedNavigationContext } from "fond/widgets";
import StackedNavigationHeader from "fond/widgets/StackedNavigation/StackedNavigationHeader";

import { closeUploadPanel } from "../redux";
import { getCurrentProjectUploads } from "..";

import LayerGroupUploadForm from "./upload/LayerGroupUploadForm";

const UploadAddresses: React.FC = () => {
  const { open, clear, goBack } = useStackedNavigationContext();
  const dispatch = useAppDispatch();
  const uploadPopupLayerGroupId = useAppSelector((state) => state.project.uploadPopupLayerGroupId);
  const inputLayerGroup = inputLayerGroups[uploadPopupLayerGroupId];
  const upload = useAppSelector((state) => inputLayerGroup && getCurrentProjectUploads(state.project)[inputLayerGroup.id]);
  const defaultIsReplacing = useAppSelector((state) => state.project.isReplacing || false);

  const onSuccessfulUpload = () => {
    clear();
    if (inputLayerGroup.id === "spanPole") open("draw");
  };

  const handleBack = () => {
    dispatch(closeUploadPanel(inputLayerGroup.id));

    if (upload && upload.uploadComplete) {
      // If upload is completed but data is being processed, back button should navigate user back to root panel
      clear();
    } else {
      goBack();
    }
  };

  return (
    <>
      <StackedNavigationHeader onBackButtonClick={handleBack} title="Upload" />
      <LayerGroupUploadForm
        layerGroupId={uploadPopupLayerGroupId}
        defaultIsReplacing={defaultIsReplacing}
        onCancel={handleBack}
        onSuccess={onSuccessfulUpload}
      />
    </>
  );
};

export default UploadAddresses;
